import {serializeObject} from './serializeObject'
import {showErrorMessage, hideErrorMessage} from './errorHandler'
import {toggleOtherFields} from './toggles'
import {validateDob, validateIfFutureDate} from './validation'
import { calculateAge, formatDate } from './helpers'
import { updatePriceByRemovingNdisDependant } from '../priceChange'

export function initSelect2() {
    $('.select-2').select2();

    $("select[name='VisaType']").change(function () {

        var visaTypeWeb = $(this).find("option:selected").data("web");
        const $parentForm = $(this).closest("form");
        const $errorMsg = $parentForm.find(".visa-type-error-msg");
        const $nextButton = $parentForm.find("button.onunload-loading-button");

        if (visaTypeWeb === "N") {
            $errorMsg.removeClass("hidden");
            $nextButton.hide();
        } else {
            $errorMsg.addClass("hidden");
            $nextButton.show();
        }

    });

    $(document).on('select2:open', () => {
        document.querySelector('.select2-search__field').focus();
    });
};

export function initSelectableEmptyOption(form: HTMLFormElement) {
    const selectElements = form.querySelectorAll(".selectable-empty-option");
    const EMPTY_OPTION_SELECTED_CLASS = "empty-option-selected";
    selectElements.forEach(elem => {

        elem.addEventListener("change", event => {
            const select = event.target;

            if (select.value === '') {
                select.classList.add(EMPTY_OPTION_SELECTED_CLASS);
            } else {
                select.classList.remove(EMPTY_OPTION_SELECTED_CLASS);
            }
        });
    });
};

export function initBsbValidation(form: HTMLFormElement) {
    async function checkBsb(value: any) {
        const response = await fetch(`/umbraco/api/bsbapi/isvalid?bsb=${value}`, {
            headers: {
                Accept: 'application/json',
            }
        });
        if (response.status !== 200) {
            throw Error(response.statusText);
        }
        const response_1 = response;
        return await response_1.json();
    }

    $(".bsb").mask("000-000");

    const bsbElements = form.querySelectorAll(".bsb");
    bsbElements.forEach(element => {

        element.addEventListener("input", event => {
            const elem = event.target;
            const value = elem.value;
            const infoElem = form.querySelector(elem.dataset.infoelem);
            const errorMessage = "Please ensure that your BSB is correct.";

            element.setCustomValidity("");
            infoElem.classList.add("hidden");
            elem.classList.remove("error");

            if (value.length < 7) {
                console.log('less than 7');
            } else {
                checkBsb(value)
                    .then(result => {
                        console.log(result);
                        if (!result.isValid) {
                            element.setCustomValidity(errorMessage);
                            element.reportValidity();
                            elem.classList.add("error");
                        } else {
                            infoElem.querySelector("p").innerHTML = result.branchName;
                            infoElem.classList.remove("hidden");
                        }
                    })
            }
        })
    })
}

export function initDependants() {
    const newDependentButton = document.getElementById("btn-new-dependent") as HTMLButtonElement;
    // Would you like to add another dependant to your coverage?
    const newDependentPanel = document.getElementById("panel-new-dependent") as HTMLElement;
    // Add a dependant form
    const addDependantForm = document.getElementById('add-dependent-form') as HTMLFormElement;
    const submitForm = document.getElementById('data-join-step');
    const submitButton = document.querySelector('button.dependants-submit') as HTMLButtonElement;
    const isDisabilityCoverType = submitForm.getAttribute('data-is-disability-cover-type') === 'True';

    const maxDependants = parseInt(submitForm.getAttribute('data-max-dependants'), 10);
    const maxAge = parseInt(submitForm.getAttribute('data-max-dependant-age'), 10);
    const minAge = parseInt(submitForm.getAttribute('data-min-dependant-age'), 10);
    const addThisDependantButton = document.querySelector("#btn-add-dependent") as HTMLButtonElement;
    
    const showNextButton = () => {
        submitButton.classList.remove('hidden');
    }

    const hideNextButton = () => {
        submitButton.classList.add('hidden');
    }

    const autoFillGender = () => {
        const dependantRelationshipSelect = addDependantForm.querySelector('#DependantRelationship') as HTMLSelectElement;
        const genderSelect = addDependantForm.querySelector('#DependantGender') as HTMLSelectElement;
        const genderSelectWrapper = genderSelect.closest<HTMLElement>('.select-field');
        dependantRelationshipSelect.addEventListener("change", () => {
            const [
                selectedOption,
            ] = [...dependantRelationshipSelect.querySelectorAll('option')].filter((el) => el.selected);

            if (selectedOption) {
                if (selectedOption.innerHTML.match(/son/i)) {
                    genderSelect.value = "M";
                    genderSelectWrapper.classList.add('hidden');
                } else if (selectedOption.innerHTML.match(/daughter/i)) {
                    genderSelect.value = "F";
                    genderSelectWrapper.classList.add('hidden');
                } else {
                    genderSelectWrapper.classList.remove('hidden');
                    genderSelect.value = "";
                }
            } else {
                genderSelectWrapper.classList.remove('hidden');
                genderSelect.value = "";
            }
        });
    }
    autoFillGender();

    const fillInDependantNumbers = () => {
        const dataPanels = submitForm.querySelectorAll('[data-dependant-panel]');
        const dataPanelCount = dataPanels.length;

        dataPanels.forEach((dataPanel, index) => {
            dataPanel.querySelector('.dependant-number').innerHTML = `${index + 1}`;
        });

        addDependantForm.querySelector('.dependant-number').innerHTML = `${dataPanelCount + 1}`;
    }

    const toggleAddDependantPanels = () => {
        const dataPanelCount = submitForm.querySelectorAll('[data-dependant-panel]').length;

        fillInDependantNumbers();
        if (dataPanelCount == 0) {
            addDependantForm.classList.remove('hidden');
            newDependentPanel.classList.add('hidden');
            hideNextButton();
        } else {
            showNextButton();
            if (dataPanelCount >= maxDependants) {
                addDependantForm.classList.add('hidden');
                newDependentPanel.classList.add('hidden');
            } else {
                addDependantForm.classList.toggle('hidden');
                newDependentPanel.classList.toggle('hidden');
            }
        }
    }

    const initialToggleAddDependantPanels = () => {
        const dataPanelCount = submitForm.querySelectorAll('[data-dependant-panel]').length;

        fillInDependantNumbers();
        if (dataPanelCount == 0) {
            addDependantForm.classList.remove('hidden');
            newDependentPanel.classList.add('hidden');
            hideNextButton();
        } else {
            showNextButton();
            if (dataPanelCount >= maxDependants) {
                addDependantForm.classList.add('hidden');
                newDependentPanel.classList.add('hidden');
            } else {
                addDependantForm.classList.add('hidden');
                newDependentPanel.classList.remove('hidden');
            }
        }
    }

    // Toggle the add dependent form
    newDependentButton.addEventListener("click", () => {
        toggleAddDependantPanels();
    });

    // Listen for all clicks as the button might not exist yet
    document.addEventListener('click', function (event) {
        const target = event.target as HTMLElement;

        if (target.matches('.dependent-remove')) {
            const dependentPanel = target.closest('[data-dependant-panel]');
            const dependantId = dependentPanel?.dataset.id;
            updatePriceByRemovingNdisDependant(dependantId);            
            dependentPanel.remove();

            const dataPanelCount = submitForm.querySelectorAll('[data-dependant-panel]').length;
            if (dataPanelCount === 0) {
                addDependantForm.classList.remove('hidden');
                newDependentPanel.classList.add('hidden');
                hideNextButton();
            } else {
                showNextButton();
                if (submitForm.querySelectorAll('[data-dependant-panel]').length < maxDependants) {
                    if (addDependantForm.classList.contains('hidden')) {
                        newDependentPanel.classList.remove('hidden');
                    }
                }
            }

            fillInDependantNumbers();
        }
    }, false);

    // Trigger process of adding a new dependent if form is valid
    addDependantForm.addEventListener('submit', (event: Event) => {
        event.preventDefault();

        const panelTemplate = document.querySelector('#dependant-template > *');
        const clonedPanel = panelTemplate.cloneNode(true) as HTMLElement;
        const data = serializeObject(addDependantForm);

        // Pretty select values
        const relationships = {};
        clonedPanel.querySelectorAll('.DependantRelationship option')
            .forEach((el) => {
                const option = el as HTMLOptionElement;
                relationships[option.value] = option.innerHTML;
            });

        const genders = {};
        clonedPanel.querySelectorAll('.DependantGender option')
            .forEach((el) => {
                const option = el as HTMLOptionElement;
                genders[option.value] = option.innerHTML;
            });

        // Update values in cloned form fields
        Object.keys(data).map((key) => {
            const el = clonedPanel.querySelector(`.${key}`) as HTMLInputElement | HTMLSelectElement;
            el.value = data[key];
        });


        // Format date


        // Set properly formatted panel values
        clonedPanel.querySelector('.firstname').innerHTML = data['DependantFirstName'];
        clonedPanel.querySelector('.middlename').innerHTML = data['DependantOtherName'];
        clonedPanel.querySelector('.surname').innerHTML = data['DependantSurname'];
        clonedPanel.querySelector('.relationship').innerHTML = relationships[data['DependantRelationship']];
        clonedPanel.querySelector('.dob').innerHTML = formatDate(data['DependantDobYear'], parseInt(data['DependantDobMonth'], 10) - 1, parseInt(data['DependantDobDay'], 10));
        clonedPanel.querySelector('.gender').innerHTML = genders[data['DependantGender']];

        // Hide/Show NDIS field summary (NDIS Eligibility and NDIS Number)
        const ndisEligibilityElem = clonedPanel.querySelector('.ndisEligibility');
        if (ndisEligibilityElem) {

            const ndisEligible = data['DependantNdisEligibility'] === "Y";
            const ndisNumberElem = clonedPanel.querySelector('.ndisNumber');
            const ndisExpiry = clonedPanel.querySelector(".ndisExpiry");

            ndisEligibilityElem.innerHTML = ndisEligible ? "Yes" : "No";
            if (ndisEligible) {
                ndisNumberElem.innerHTML = data["DependantNdisNumber"];
                ndisNumberElem.parentNode.classList.remove("hidden");

                ndisExpiry.innerHTML = formatDate(data['DependantNdisYear'], parseInt(data['DependantNdisMonth'], 10) - 1, parseInt(data['DependantNdisDay'], 10));
                ndisExpiry.parentNode.classList.remove("hidden");
            } else {
                ndisNumberElem.parentNode.classList.add("hidden");
            }
        }

        // Add cloned panel to main form and reset page state
        submitForm.append(clonedPanel);

        toggleAddDependantPanels();

        addDependantForm.reset();

        if (isDisabilityCoverType) {
            addThisDependantButton.disabled = true;
            addDependantForm.querySelector(".toggle-dependant-ndis")?.classList.add("hidden");
            addDependantForm.querySelector(".dependant-dob")?.classList.add('hidden');
        }
    });

    const toggleEventsForNdisEligibility = (form: HTMLFormElement) => {


        if (isDisabilityCoverType) {
            var dependantNdisEligiblityCheckbox = form.querySelectorAll("[name='DependantNdisEligibility']");
            dependantNdisEligiblityCheckbox.forEach((cb: {
                addEventListener: (arg0: string, arg1: (e: { target: { value: any; }; }) => void) => void;
            }) => {
                cb.addEventListener("change", (e: { target: { value: any; }; }) => {

                    const isDisabilityValue = e.target.value;
                    if (isDisabilityValue) {
                        form.querySelector(".dependant-dob").classList.remove('hidden');
                    }

                    if (isDisabilityValue === 'Y') {
                        validateDob(addDependantForm, 31, null, `Dependant must be 31 years old or above.`);
                        validateIfFutureDate(addDependantForm, "DependantNdisDay", "DependantNdisMonth", "DependantNdisYear")
                    } else {
                        validateDob(addDependantForm, null, 30, `Dependant must be under the age of 31.`);
                    }

                    addThisDependantButton.disabled = false;
                });
            });
        } else {
            validateDob(addDependantForm, null, maxAge, `Dependant must be under the age of ${maxAge + 1}.`);
        }


        // Set custom validation message for the NDIS number field
        const ndisNumberElement = document.getElementById("DependantNdisNumber");
        if (ndisNumberElement) {
            ndisNumberElement.addEventListener("input", () => {

                if (ndisNumberElement.validity.patternMismatch) {
                    ndisNumberElement.setCustomValidity("Your dependant’s NDIS number is a 9 digit number.");
                } else if (ndisNumberElement.validity.tooShort) {
                    ndisNumberElement.setCustomValidity("Your dependant’s NDIS number is a 9 digit number. Please enter more digits.");
                } else {
                    ndisNumberElement.setCustomValidity("");
                }

            });
        }

    };

    const showLoadingContent = () => {

        submitButton.querySelector("span[data-original]")?.setAttribute("hidden", "hidden");
        submitButton.querySelector("span[data-loader]")?.removeAttribute("hidden");
        submitButton.classList.add("loading", "disabled");
        submitButton.setAttribute("disabled", "disabled");

    };

    submitButton.addEventListener("click", (e: Event) => {

        e.preventDefault();

        if(isDisabilityCoverType)
        {
            const eligibilityElements = submitForm?.querySelectorAll("[name='DependantNdisEligibility'][value='Y']");

            const hasAnyDependantWithDisability = eligibilityElements && eligibilityElements.length > 0;
    
            if (!hasAnyDependantWithDisability) {
                showErrorMessage(submitButton, "You must enter at least one dependant that is a participant of the NDIS.");
                submitButton.reportValidity();
                return;
            }
        }
        else
        {
            // Checks if there is at least one valid dependant (e.g. 25 to 30 year old)
            const dependantPanels = submitForm?.querySelectorAll(".dependent-panel");
            let hasAnyValidDependant = false;
            dependantPanels?.forEach(panel=>{
                if(!hasAnyValidDependant)
                {
                    const dayElement = panel.querySelector(`[name="DDD"]`) as HTMLInputElement;
                    const day = dayElement.value;
                    const monthElement = panel.querySelector(`[name="DDM"]`) as HTMLSelectElement;
                    const month = monthElement.value;
                    const yearElement = panel.querySelector(`[name="DDY"]`) as HTMLInputElement;
                    const year = yearElement.value;
                    const dob = new Date(parseInt(year), parseInt(month) - 1, parseInt(day))
                    const age = calculateAge(dob);
                    hasAnyValidDependant = (age >= minAge && age <= maxAge);
                }                
            });

            if(!hasAnyValidDependant){
                showErrorMessage(submitButton, `You must add at least one ${minAge}-${maxAge} year old dependant.`);
                submitButton.reportValidity();
                return;
            }
        }
       

        showLoadingContent();
        submitForm.dispatchEvent(new Event('submit'));
        submitForm.submit();

    });

    toggleOtherFields(addDependantForm);
    toggleEventsForNdisEligibility(addDependantForm);
    initialToggleAddDependantPanels();
}

export function initReviewFields() {
    const editDetailsForm = document.querySelector<HTMLFormElement>('form.details-edit[data-join-step="edit"], form.details-edit[data-join-step="details"]');
    if (editDetailsForm === null) {
        return;
    }

    const partnerDobContainer = editDetailsForm.querySelector<HTMLElement>('.dob-container.details-partner');
    const rebateTiersContainer = editDetailsForm.querySelector<HTMLElement>('.rebate-tiers');
    const coverTypeInput = editDetailsForm.querySelector<HTMLSelectElement>('[name="CoverType"]');

    const updateFormState = () => {
        const coverType = coverTypeInput.value;
        const isSingleTierShown = coverType === "" || coverType === "single";
        const isPartnerShown = coverType == "couple" || coverType == "family" || coverType == "extendedfamily";
        const hasDependants = coverType == "sole" || coverType == "family";
        const ageOfOldestContainer = editDetailsForm.querySelector("#age-of-oldest-dependant-container");

        if (ageOfOldestContainer) {
            if (hasDependants) {
                ageOfOldestContainer.classList.remove('hidden');
                ageOfOldestContainer.querySelectorAll('select').forEach((el) => {
                    el.setAttribute('required', 'required');
                })
            } else {
                ageOfOldestContainer.classList.add('hidden');
                ageOfOldestContainer.querySelectorAll('select').forEach((el) => {
                    el.removeAttribute('required');
                    hideErrorMessage(el as HTMLSelectElement);
                })
            }
        }
        
        if (isPartnerShown) {
            partnerDobContainer.classList.remove('hidden');
            partnerDobContainer.querySelectorAll('input, select').forEach((el) => {
                el.setAttribute('required', 'required');
            })
        } else {
            partnerDobContainer.classList.add('hidden');
            partnerDobContainer.querySelectorAll('input, select').forEach((el) => {
                el.removeAttribute('required');
                hideErrorMessage(el as HTMLInputElement);
            })
        }

        if (rebateTiersContainer) {
            rebateTiersContainer.querySelectorAll('.single, .couple').forEach((el) => {
                if (isSingleTierShown) {
                    if (el.classList.contains('single')) {
                        el.classList.remove('hidden');
                    } else {
                        el.classList.add('hidden');
                    }
                } else {
                    if (el.classList.contains('single')) {
                        el.classList.add('hidden');
                    } else {
                        el.classList.remove('hidden');
                    }
                }
            });
        }

    };

    validateDob(editDetailsForm);
    coverTypeInput.addEventListener("change", updateFormState);
    updateFormState();
}

// This function is now obsolete, please refer to priceService.initPaymentFrequencyChange() function
export function initGetQuoteFunction(form: HTMLFormElement) {
    const elem = form.querySelector("#DeductionBillingGroupId");
    const premiumElems = document.querySelectorAll(".premium-payment");
    const greenBannerFrequencyElem = document.querySelector(".green-banner-frequency");
    const stickyHeaderFrequencyElem = document.querySelector(".sticky-frequency");

    elem.addEventListener("change", function () {
        const endpoint = `/umbraco/surface/JoinStep3_4PayDetails/getquote?billingGroupId=${elem.value}`;
        let wordingPerFreqLabel = "";
        const selectedText = elem?.options[elem.selectedIndex].text;

        // paymentDetailsContainer?.classList.add("loading-container");
        elem.disabled = true;

        if (selectedText.includes("Weekly")) {
            wordingPerFreqLabel = "per week";
        } else if (selectedText.includes("Fortnight")) {
            wordingPerFreqLabel = "per fortnight";
        } else {
            wordingPerFreqLabel = "per " + selectedText.replace("Monthly", "month").toLowerCase();
        }

        fetch(endpoint, {
            headers: {
                Accept: 'application/json',
            }
        })
            .then(response => {
                if (response.status !== 200) {
                    throw Error(response.statusText);
                }
                return response;
            })
            .then(response => response.json())
            .then(jsonObject => {

                // errorContainer.style.display = 'none';

                // // Initial Payment
                // if(jsonObject.InitialPayment !== "" && jsonObject.InitialPayment !== null){
                //   initialPaymentContainer.style.display = "block";
                //   initialPaymentElem.innerHTML = jsonObject.InitialPayment;
                // }
                // else{
                //   initialPaymentContainer.style.display = "none";
                // }

                // Future Payment
                if (jsonObject.FuturePayment !== "" && jsonObject.FuturePayment !== null) {
                    // recurringPaymentContainer.style.display = "block";
                    // recurringPaymentElem.innerHTML = jsonObject.FuturePayment;
                    premiumElems.forEach(elem => elem.innerHTML = jsonObject.FuturePayment);
                }
                // else{
                //   recurringPaymentContainer.style.display = "none";
                // }

                // Frequency Wording
                // wordingFrequencyElem.innerHTML = wordingFreqLabel;
                // wordingPerFrequencyElem.innerHTML = wordingPerFreqLabel;
                greenBannerFrequencyElem.innerHTML = selectedText.split(' ')[0];
                stickyHeaderFrequencyElem.innerHTML = wordingPerFreqLabel.split(' ').slice(0, 2).join(" ");

                // paymentDetailsContainer?.classList.remove("loading-container");
                elem.disabled = false;
            })
            .catch(() => {

                // paymentDetailsContainer?.classList.remove("loading-container");
                // recurringPaymentContainer.style.display = "none";
                // initialPaymentContainer.style.display = "none";
                // errorContainer.style.display = "block";
                elem.disabled = false;
            });

    });

    elem.dispatchEvent(new Event('change'));
}